import { render, staticRenderFns } from "./ApuracaoAcaoListaTabela.vue?vue&type=template&id=8ba47a6e"
import script from "./ApuracaoAcaoListaTabela.vue?vue&type=script&lang=js"
export * from "./ApuracaoAcaoListaTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports